'use client';

import { useTranslations } from 'next-intl';
import { TextButton } from '@zillow/constellation-10';
import { resendRow } from './otpCodeEntry.styles';

export type OtpResendButtonProps = {
  onResend: () => void;
  isSending: boolean;
  cooldownSeconds: number;
  disabled: boolean;
};

export function OtpResendButton({ onResend, isSending, cooldownSeconds, disabled }: OtpResendButtonProps) {
  const t = useTranslations('auth');

  return (
    <div className={resendRow}>
      <TextButton type="button" onClick={onResend} disabled={disabled}>
        {/* Sending, cooling down, and ready are mutually exclusive: the cooldown does not
            begin until a code is out, so the countdown can never reach zero mid-send and
            strand the control on a progress label. */}
        {isSending
          ? t('otpResending')
          : cooldownSeconds > 0
            ? t('otpResendCooldown', { seconds: cooldownSeconds })
            : t('otpResend')}
      </TextButton>
    </div>
  );
}
